export default __webpack_public_path__ + "static/media/White_Cloud_large_1.e83c2f6d.jpg";